module.exports = __webpack_public_path__ + "img/1698154995871.4bc60621.jpg";